import React, { useState } from 'react';
import { BookOpen, Headphones, NotebookPen, Lock } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function PremiumBonusSection() {
  const [openBenefits, setOpenBenefits] = useState<{
    [key: number]: boolean;
  }>({});
  const toggleBenefits = (bonusNumber: number) => {
    setOpenBenefits(prev => ({
      ...prev,
      [bonusNumber]: !prev[bonusNumber]
    }));
  };
  const scrollToSecretSection = () => {
    const secretSection = document.getElementById('zona-exclusiva');
    if (secretSection) {
      secretSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const bonuses = [{
    icon: BookOpen,
    number: 1,
    title: 'Manual de Decisiones Claras con Tarot',
    subtitle: 'Cómo acceder a respuestas tan obvias sobre amor, dinero y bienestar que ignorarlas sería sabotear tu propia vida',
    value: '$28.99',
    description: 'El ebook completo donde aprendes a usar el tarot como una herramienta lógica para pensar mejor, no como algo mágico para adivinar tu destino.',
    note: 'Este bono elimina la percepción de suerte y convierte al tarot en un recurso mental estructurado para decidir mejor.'
  }, {
    icon: Headphones,
    number: 2,
    title: 'Audiolibro Oficial',
    subtitle: '',
    value: '$21.97',
    description: 'Escucha el contenido completo sin tener que sentarte a leer. Consúmelo mientras manejas, trabajas o entrenas. Convierte tiempos muertos en progreso real.',
    benefits: ['No necesitas "encontrar tiempo"', 'Aprendes sin esfuerzo adicional', 'Interiorizas el contenido por repetición', 'Avanzas sin fricción']
  }, {
    icon: NotebookPen,
    number: 3,
    title: 'El Cuaderno de Preguntas que Cambian tu Vida',
    subtitle: '',
    value: '$17.99',
    description: 'Este workbook te obliga a dejar de autoengañarte y llegar a una decisión real. Son preguntas diseñadas para exponerte tu verdad, no para hacerte sentir bien.',
    benefits: ['Identificas exactamente qué quieres', 'Descubres qué te detiene y por qué', 'Tomas decisiones sin ansiedad', 'Dejas de repetir patrones emocionales']
  }, {
    icon: Lock,
    number: 4,
    title: 'Zona Exclusiva para Compradores',
    subtitle: '',
    value: '$47.87',
    description: 'Acceso privado solo para clientes. Aquí tienes contenido adicional, recursos exclusivos y 2 regalos de bienvenida que no existen públicamente.',
    benefits: ['Ventaja injusta frente a quienes no compran', 'Material extra que acelera tus resultados', 'Sensación de pertenecer a una comunidad "que sí hace"', 'Incentivos que no obtendrás en ningún otro lado'],
    hasButton: true
  }];
  return <section id="bonos" className="py-20 px-4 bg-[#0C0A09] border-t border-[#3b3330] relative overflow-hidden" data-id="element-247">
      {/* Background ambient effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#CFA86A]/5 via-transparent to-transparent opacity-30" data-id="element-248" />

      {/* Anchor point for smooth scrolling */}
      <div id="bonos-exclusivos" className="absolute -mt-20" data-id="element-249" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-250">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-251">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5EDE0] mb-6 font-serif" data-id="element-252">
            Bonos Premium Incluidos
          </h2>

          <div className="inline-block" data-id="element-253">
            <div className="flex items-center justify-center gap-4 mb-3" data-id="element-254">
              <span className="text-lg md:text-2xl text-[#F5EDE0]/50 line-through" data-id="element-255">
                Valor Total: $116.89
              </span>
            </div>
            <div className="text-4xl md:text-5xl font-bold text-[#CFA86A] px-6 md:px-8 py-3 md:py-4 rounded-lg bg-[#CFA86A]/5 border border-[#CFA86A]/20" style={{
            textShadow: '0 0 30px rgba(207, 168, 106, 0.5)'
          }} data-id="element-256">
              HOY SOLO $24.99
            </div>
          </div>
        </motion.div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-2 gap-4 md:gap-8 mb-16" data-id="element-257">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          const isOpen = openBenefits[bonus.number] || false;
          return <motion.div key={bonus.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group relative" data-id="element-258">
                {/* Gradient border effect */}
                <div className="absolute -inset-0.5 bg-gradient-to-br from-[#CFA86A]/30 via-[#CFA86A]/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 blur transition-opacity duration-500" data-id="element-259" />

                <div className="relative p-4 md:p-8 rounded-xl border border-[#CFA86A]/20 bg-gradient-to-br from-[#0C0A09] via-[#0C0A09] to-[#1a1410] backdrop-blur-sm transition-all duration-300 group-hover:border-[#CFA86A]/40" style={{
              boxShadow: '0 4px 40px rgba(207, 168, 106, 0.08)'
            }} data-id="element-260">
                  {/* Header with Icon, Title, and Value */}
                  <div className="flex flex-col md:flex-row items-start gap-3 md:gap-4 mb-4 md:mb-5" data-id="element-261">
                    {/* Icon with glow effect */}
                    <div className="relative flex-shrink-0" data-id="element-262">
                      <div className="w-12 h-12 md:w-16 md:h-16 rounded-2xl flex items-center justify-center border border-[#CFA86A]/30 bg-gradient-to-br from-[#CFA86A]/10 to-transparent backdrop-blur-sm transition-all duration-300 group-hover:border-[#CFA86A]/50 group-hover:shadow-[0_0_20px_rgba(207,168,106,0.3)]" data-id="element-263">
                        <Icon className="w-6 h-6 md:w-8 md:h-8 text-[#CFA86A]" data-id="element-264" />
                      </div>
                      {/* Glow effect */}
                      <div className="absolute inset-0 rounded-2xl bg-[#CFA86A]/20 blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-300" data-id="element-265" />
                    </div>

                    {/* Title and Badge */}
                    <div className="flex-1 min-w-0" data-id="element-266">
                      <div className="inline-block px-2 py-0.5 md:px-2.5 md:py-1 rounded-full bg-[#CFA86A]/10 border border-[#CFA86A]/30 mb-2" data-id="element-267">
                        <span className="text-[9px] md:text-xs text-[#CFA86A] font-bold tracking-widest" data-id="element-268">
                          BONO #{bonus.number}
                        </span>
                      </div>
                      <h3 className="text-sm md:text-xl font-bold text-[#F5EDE0] leading-tight mb-1" data-id="element-269">
                        {bonus.title}
                      </h3>
                    </div>

                    {/* Value badge */}
                    <div className="flex-shrink-0 self-start md:text-right" data-id="element-270">
                      <div className="px-2 py-1 md:px-3 md:py-1.5 rounded-lg bg-[#CFA86A]/10 border border-[#CFA86A]/30" data-id="element-271">
                        <div className="text-[9px] md:text-xs text-[#F5EDE0]/60 mb-0.5" data-id="element-272">
                          Valor
                        </div>
                        <div className="text-base md:text-2xl font-bold text-[#CFA86A] whitespace-nowrap" data-id="element-273">
                          {bonus.value}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Subtitle */}
                  {bonus.subtitle && <p className="text-xs md:text-base text-[#F5EDE0]/70 italic mb-3 md:mb-4 leading-relaxed pl-1" data-id="element-274">
                      {bonus.subtitle}
                    </p>}

                  {/* Description */}
                  <p className="text-xs md:text-base text-[#F5EDE0]/80 mb-4 md:mb-5 leading-relaxed" data-id="element-275">
                    {bonus.description}
                  </p>

                  {/* Benefits - Collapsible */}
                  {bonus.benefits && <div className="mb-3 md:mb-4" data-id="element-276">
                      <button onClick={() => toggleBenefits(bonus.number)} className="w-full flex items-center justify-between gap-2 md:gap-3 px-3 py-2 md:px-4 md:py-3 rounded-lg border border-[#CFA86A]/30 bg-gradient-to-r from-[#CFA86A]/5 to-transparent hover:from-[#CFA86A]/10 hover:border-[#CFA86A]/50 transition-all duration-300 cursor-pointer group/btn" style={{
                  boxShadow: isOpen ? '0 0 20px rgba(207, 168, 106, 0.15)' : 'none'
                }} data-id="element-277">
                        <div className="flex items-center gap-2 md:gap-3" data-id="element-278">
                          {/* Treasure Chest Icon */}
                          <motion.div animate={{
                      rotateX: isOpen ? 45 : 0
                    }} transition={{
                      duration: 0.4,
                      ease: [0.22, 1, 0.36, 1]
                    }} className="relative flex-shrink-0" data-id="element-279">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#CFA86A] md:w-[22px] md:h-[22px]" data-id="element-280">
                              <rect x="3" y="10" width="18" height="10" rx="2" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-281" />
                              <path d="M3 14h18" stroke="currentColor" strokeWidth="2" data-id="element-282" />
                              <rect x="6" y="6" width="12" height="4" rx="1" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-283" />
                              <circle cx="12" cy="14" r="1.5" fill="currentColor" data-id="element-284" />
                            </svg>

                            {/* Golden glow when open */}
                            <AnimatePresence data-id="element-285">
                              {isOpen && <motion.div initial={{
                          opacity: 0,
                          scale: 0.8
                        }} animate={{
                          opacity: 1,
                          scale: 1
                        }} exit={{
                          opacity: 0,
                          scale: 0.8
                        }} transition={{
                          duration: 0.3
                        }} className="absolute inset-0 -z-10" style={{
                          filter: 'blur(8px)',
                          background: 'radial-gradient(circle, rgba(207, 168, 106, 0.6), transparent 70%)'
                        }} data-id="element-286" />}
                            </AnimatePresence>
                          </motion.div>

                          <span className="text-[10px] md:text-sm font-semibold text-[#CFA86A] group-hover/btn:brightness-110 transition-all" data-id="element-287">
                            Beneficios
                          </span>
                        </div>

                        {/* Chevron indicator */}
                        <motion.div animate={{
                    rotate: isOpen ? 180 : 0
                  }} transition={{
                    duration: 0.3,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="flex-shrink-0" data-id="element-288">
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#CFA86A] md:w-4 md:h-4" data-id="element-289">
                            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-290" />
                          </svg>
                        </motion.div>
                      </button>

                      <AnimatePresence data-id="element-291">
                        {isOpen && <motion.ul initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.4,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="space-y-2 md:space-y-2.5 overflow-hidden mt-2 md:mt-3 pl-3 md:pl-4 pr-1 md:pr-2" data-id="element-292">
                            {bonus.benefits.map((benefit, idx) => <motion.li key={idx} initial={{
                      opacity: 0,
                      x: -10
                    }} animate={{
                      opacity: 1,
                      x: 0
                    }} transition={{
                      duration: 0.3,
                      delay: idx * 0.05
                    }} className="flex items-start gap-2 text-[10px] md:text-sm text-[#F5EDE0]/80" data-id="element-293">
                                <span className="text-[#CFA86A] mt-0.5 text-xs md:text-base" data-id="element-294">
                                  ✓
                                </span>
                                <span className="leading-relaxed" data-id="element-295">
                                  {benefit}
                                </span>
                              </motion.li>)}
                          </motion.ul>}
                      </AnimatePresence>
                    </div>}

                  {/* Button for Bonus #4 */}
                  {bonus.hasButton && <button onClick={scrollToSecretSection} className="w-full mt-3 md:mt-4 px-4 py-2 md:px-6 md:py-3 rounded-lg bg-gradient-to-r from-[#CFA86A] to-[#b8955a] text-[#0C0A09] text-xs md:text-base font-bold tracking-wide transition-all duration-300 hover:shadow-[0_0_30px_rgba(207,168,106,0.4)] hover:scale-[1.02] flex items-center justify-center gap-1 md:gap-2" data-id="element-296">
                      <Lock className="w-3 h-3 md:w-4 md:h-4" data-id="element-297" />
                      <span className="hidden sm:inline" data-id="element-298">
                        VER ZONA EXCLUSIVA
                      </span>
                      <span className="sm:hidden" data-id="element-299">VER ZONA</span>
                    </button>}

                  {/* Note */}
                  {bonus.note && <p className="text-[10px] md:text-sm text-[#F5EDE0]/60 italic mt-4 md:mt-5 pt-4 md:pt-5 border-t border-[#CFA86A]/10 leading-relaxed" data-id="element-300">
                      {bonus.note}
                    </p>}
                </div>
              </motion.div>;
        })}
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-12" data-id="element-301">
          <a href="https://misticavibes.com/cart/43803698200627:1" className="inline-block px-12 py-5 rounded-xl bg-gradient-to-r from-[#CFA86A] to-[#b8955a] text-[#0C0A09] text-xl font-bold tracking-wide transition-all duration-300 hover:shadow-[0_0_50px_rgba(207,168,106,0.5)] hover:scale-105" data-id="element-302">
            Comprar ahora por solo $24.99
          </a>
          <p className="text-[#F5EDE0]/60 text-sm mt-4 font-normal" data-id="element-303">
            Compra nuestras cartas del tarot con todos los bonos incluidos.
          </p>
          <p className="text-sm text-[#F5EDE0]/50 mt-2" data-id="element-304">
            Acceso inmediato a todos los bonos después de la compra
          </p>
        </motion.div>
      </div>
    </section>;
}